export default "__VITE_ASSET__36a3ee55__"